import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import type { Place } from '../data/places';
interface PlaceCardProps {
  place: Place;
  index: number;
}
export function PlaceCard({
  place,
  index
}: PlaceCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.03,
    duration: 0.4
  }} className="group" data-id="element-195">
      <Link to={`/place/${place.id}`} className="block h-full" data-id="element-196">
        <div className="p-6 border border-gray-200 hover:border-amber-500 transition-all duration-300 h-full flex flex-col bg-white" data-id="element-197">
          {/* Category Badge */}
          <span className="px-3 py-1 border border-gray-200 text-gray-600 text-xs font-light uppercase tracking-widest inline-block mb-4 self-start" data-id="element-198">
            {place.category}
          </span>

          {/* Title */}
          <h3 className="text-xl font-light text-gray-900 mb-2 group-hover:text-amber-600 transition-colors" data-id="element-199">
            {place.name}
          </h3>

          {/* Location */}
          <div className="flex items-center gap-2 text-gray-500 mb-4" data-id="element-200">
            <MapPin className="w-3 h-3" strokeWidth={1.5} data-id="element-201" />
            <span className="text-xs font-light" data-id="element-202">{place.location}</span>
          </div>

          {/* Description */}
          <p className="text-gray-600 text-sm leading-relaxed mb-4 font-light line-clamp-3 flex-1" data-id="element-203">
            {place.description}
          </p>

          {/* Highlights */}
          <div className="mb-4" data-id="element-204">
            <h4 className="text-xs font-light text-gray-500 uppercase tracking-wider mb-2" data-id="element-205">
              Highlights
            </h4>
            <div className="space-y-1" data-id="element-206">
              {place.highlights.slice(0, 2).map((highlight, i) => <div key={i} className="flex items-start gap-2 text-xs text-gray-600 font-light" data-id="element-207">
                  <div className="w-1 h-1 bg-amber-500 rounded-full mt-1.5 flex-shrink-0" data-id="element-208"></div>
                  <span className="line-clamp-1" data-id="element-209">{highlight}</span>
                </div>)}
            </div>
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-4" data-id="element-210">
            {place.categories.slice(0, 2).map(cat => <span key={cat} className="text-xs text-gray-500 font-light" data-id="element-211">
                {cat}
              </span>)}
          </div>

          {/* CTA */}
          <div className="flex items-center gap-2 text-gray-900 font-light group-hover:text-amber-600 transition-colors text-xs uppercase tracking-widest pt-3 border-t border-gray-200" data-id="element-212">
            <span data-id="element-213">Discover</span>
            <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" strokeWidth={1.5} data-id="element-214" />
          </div>
        </div>
      </Link>
    </motion.div>;
}